import {createApp, Plugin} from 'vue';

import App from './App.vue';

import {setupContext} from '@/profile-creation-wizard/config/AppContextSetuper';
import '@/profile-creation-wizard/components/for-creation/ProfileCreationForm';
import store from '@/profile-creation-wizard/components/for-creation/store';
import router from '@/profile-creation-wizard/router';
import {features} from '@/profile-creation-wizard/common/ui/plugins/features';
import {pageContext} from '@/common/plugins/pageContext';
import {RegisteredDependencies} from '@/profile-creation-wizard/common/DependencyInjection';
import {I18nPlugin} from '@/common/plugins/i18n';
import {modal} from '@/common/plugins/modal';
import {setUpAlerting} from '@malt/alerting-vue3';

import {RegisterExternalComponentsPlugin} from '@malt/joy-entrypoint/src/vue/plugins';

async function main() {
    await setupContext();

    const app = createApp(App);
    const registredRepositories = RegisteredDependencies.all();
    Object.getOwnPropertySymbols(registredRepositories).forEach((domainServiceKey) => {
        // @ts-ignore
        app.provide(domainServiceKey, registredRepositories[domainServiceKey]);
    });
    app.use(router);
    app.use(store);
    app.use(features);
    app.use(pageContext);
    app.use(I18nPlugin as Plugin);
    app.use(modal);

    app.use(RegisterExternalComponentsPlugin, {
        registerExternalComponents: ['autocomplete', 'calendar', 'multiselect'],
    });

    if (window.SENTRY_CONFIGURATION) {
        setUpAlerting({
            configuration: window.SENTRY_CONFIGURATION,
            app,
            connectedUser: window.CONNECTED_USER,
            router,
        });
    }

    app.mount('#app');
}

main();
